/**
 * @desc staffAccountList
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.OrganizationStaffRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/organizationStaff/staffAccountList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
